import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as settingsActions from "../../../redux/actions/settings.js";
import * as dashboardActions from "../../../redux/actions/dashboard.js";
import Card from "../../components/Card.jsx";
import InputSwitch from "../../components/InputSwitch.jsx";
import Button from "../../components/Button.jsx";
import ChangePasswordSettingsForm from "./ChangePassingSettingsForm.jsx";
import SweetAlert from "../../components/SweetAlert.jsx";

export default function AccountPageBasicSettings() {
	const dispatch = useDispatch();

	const settings = useSelector((state) => state.settings);
	const dashboard = useSelector((state) => state.dashboard);
	const [showingClearCategoriesPopup, updateShowingClearCategoriesPopup] = useState(false);

	const { selectedDate } = dashboard;

	const {
		showTotalsWithinEachCategoryFeatureActive,
		separateBudgetTabsFeatureActive,
		calendarFeatureActive,
		freeFormBudgetingFeatureActive
	} = settings;

	function everyDollarBudgetingChange(event) {
		const { target } = event;

		let setTo = null;
		switch(target.value) {
			case 'everydollar':
				setTo = false;
				break;
			case 'free':
				setTo = true;
				break;
			default:
				throw new Error('Unexpected value');
		}
		console.log(target.value, target.checked);
		dispatch(settingsActions.toggleFreeFormBudget(setTo));
	}

	const toggleCalendarEnabledSetting = (event) => {
		dispatch(settingsActions.toggleCalendarEnabledSetting(event.target.checked));
	};

	const toggleSeparateTabsForEachBudgetCategory = (event) => {
		dispatch(settingsActions.toggleSeparateTabsForEachBudgetCategory(event.target.checked));
	};

	const toggleShowTotalsWithinEachCategory = (event) => {
		dispatch(settingsActions.toggleShowTotalsWithinEachCategory(event.target.checked));
	};

	const deleteAllTransactionsPopupInitiate = () => {
		dispatch(dashboardActions.deleteAllTransactionsPopupInitiate());
	};

	const clearCategoriesConfirm = () => {
		return dispatch(dashboardActions.resetCategories());
	};

	const clearCategoriesCancel = () => {
		updateShowingClearCategoriesPopup(false);
	};
	const clearCategoriesClick = () => {
		updateShowingClearCategoriesPopup(true);
	};

	return (
		<React.Fragment>
			{showingClearCategoriesPopup &&
			<SweetAlert
				header='Are you sure?'
				icon={SweetAlert.icons.warning}
				confirmButtonText='Yes, Reset Them!'
				onConfirm={clearCategoriesConfirm}
				onCancel={clearCategoriesCancel}
				confirmedTitle='Reset!'
				confirmedText='Your categories have been reset.'
				showConfirmButton={true}
				showCancelButton={true}
			>
				You will have to recategorize your transactions!
			</SweetAlert>
			}
			<div className='row'>
				<div className='col s12'>
					<Card
						cardTitle='Features'
					>
						<InputSwitch
							checked={calendarFeatureActive}
							onChange={toggleCalendarEnabledSetting}
						>
							Calendar / Grocery List
						</InputSwitch>

						{
							<InputSwitch
								checked={separateBudgetTabsFeatureActive}
								onChange={toggleSeparateTabsForEachBudgetCategory}
							>
								Separate Tabs for Each Budget Category
							</InputSwitch>
						}
						<InputSwitch
							checked={showTotalsWithinEachCategoryFeatureActive}
							onChange={toggleShowTotalsWithinEachCategory}
						>
							Show Total Spent & Total Remaining Within Each Category
						</InputSwitch>

						<section>
							<h6>Budget Type (Countdown While Budgeting)</h6>
							<label>
								<input
									onChange={everyDollarBudgetingChange}
									checked={!freeFormBudgetingFeatureActive}
									value='everydollar'
									type="radio"

								/>
								<span>Every Dollar (Amount to Budget is based on Income For The Month)</span>
							</label>
							<label>
								<input
									onChange={everyDollarBudgetingChange}
									checked={freeFormBudgetingFeatureActive}
									value='free'
									type="radio"
								/>
								<span>Free Form Budgeting</span>
							</label>
						</section>

					</Card>
				</div>
			</div>
			<div className='row'>
				<div className='col s12'>
					<ChangePasswordSettingsForm />
				</div>
			</div>

			<div className='row'>
				<div className='col s12'>
					<Card
						cardTitle='Reset Items'
					>
						{selectedDate &&
						<div className='section'>

							<Button
								danger
								onClick={deleteAllTransactionsPopupInitiate}
							>
								<div>
									Clear
									{' '}
									<span className='date'>
								{selectedDate.format('MMMM')}{' '}{selectedDate.format('YYYY')}{' '} Transactions
								</span>
								</div>
							</Button>
						</div>
						}
						<Button
							className='clear_categories'
							danger
							onClick={clearCategoriesClick}
						>
							<div>
								Reset All Categories
							</div>
						</Button>
					</Card>
				</div>
			</div>
		</React.Fragment>
	);
}
